/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { CrossLocationOpenShiftDataService, CrossLocationShiftDataService, CrossLocationTeamDataService, TeamSettingsDataService, UserProfileDataService } from "@microsoft/shifts-managers";

import { AllDataServices } from "./AllDataServices";
import ConflictDismissDataService from "./ConflictDismissDataService";
import ImportJobsDataService from "./ImportJobsDataService";
import JobDataService from "./JobDataService";
import MemberDataService from "./MemberDataService";
import NoteDataService from "./NoteDataService";
import ScheduleFiltersDataService from "./ScheduleFiltersDataService";
import ShiftDataService from "./ShiftDataService";
import ShiftRequestDataService from "./ShiftRequestDataService";
import TagDataService from "./TagDataService";
import TeamDataService from "./TeamDataService";
import TeamMemberPermissionsDataService from "./TeamMemberPermissionsDataService";
import TeamPermissionsDataService  from "./TeamPermissionsDataService";
import TeamSettingDataService from "./TeamSettingDataService";
import TenantDataService from "./TenantDataService";
import TimeClockDataService from "./TimeClockDataService";
import TimeOffReasonDataService from "./TimeOffReasonDataService";
import UserDataService from "./UserDataService";
import SmartScheduleDataService from "./SmartScheduleDataService";
import UserTeamSettingsDataService from "./UserTeamSettingsDataService";

/**
 * This exports a singleton instance of the AllDataServices class.
 *
 * When adding a new data service, follow this pattern (see UserTeamSettingsDataService as example):
 * 1. Import service → 2. Add to IAllDataServices → 3. Add property to AllDataServices
 * 4. Add constructor param → 5. Assign in constructor → 6. Add to DataServices array
 * 7. Add public getter → 8. Pass instance to constructor here
 */
const allDataServicesInstance = new AllDataServices(
    JobDataService,
    MemberDataService,
    NoteDataService,
    ScheduleFiltersDataService,
    ShiftDataService,
    ShiftRequestDataService,
    TagDataService,
    TeamSettingDataService,
    TimeOffReasonDataService,
    TeamDataService,
    TenantDataService,
    UserDataService,
    TimeClockDataService,
    ConflictDismissDataService,
    TeamPermissionsDataService,
    TeamMemberPermissionsDataService,
    ImportJobsDataService,
    new CrossLocationOpenShiftDataService(),
    new CrossLocationTeamDataService(),
    new UserProfileDataService(),
    new CrossLocationShiftDataService(),
    new TeamSettingsDataService(),
    SmartScheduleDataService,
    UserTeamSettingsDataService // User-specific configuration per team
);

export default allDataServicesInstance;